import { IModel } from '../base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { LinkedService, IViolation, IValidationContext, validateLinkedServicePermission } from 'shell-models-lib';
import { TeradataLinkedService } from '../linkedservice/teradata.linkedservice';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.teradata.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, getConnectorLegacyNameByFlag(stringResources.Teradata_DisplayText, true)),
        format(stringResources.ModelName_DatasetsTemplate, getConnectorLegacyNameByFlag(stringResources.Teradata_DisplayText, true))
    ],
    constraints: {
        linkedService: {
            model: TeradataLinkedService.MODEL // Linked service redefined
        }
    }
})
export class TeradataDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        reference: true,
        type: LinkedService.MODEL,
        constraint: {
            required: true,
            validator: async (dataset: TeradataDataset, linkedService: LinkedService, violation?: IViolation, context?: IValidationContext): Promise<IViolation[] | undefined> => {
                const result: IViolation[] = [];
                if (linkedService instanceof TeradataLinkedService && linkedService.isMashupResource) {
                    result.push({
                        context: dataset,
                        message: () => stringResources.TeradataV2ReferenceOldLinkedServiceErrorMessage,
                        doNotAutomaticallyCorrect: true
                    });
                } else if (linkedService) {
                    result.push(...validateLinkedServicePermission(linkedService, context));
                }
                return result;
            }
        }
    })
    public linkedService: LinkedService;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
